import styled, { css } from 'styled-components/macro';
import * as colors from 'src/styles/colors';
import { mobilePoint } from 'src/styles/globalStyle';
import { BsFillPatchCheckFill } from 'react-icons/bs';
import PlaceImg from 'src/components/ui-kit/PlaceImg';
import DetailBanner from 'src/components/layout/banner/DetailBanner';
import { globalComponents, PrimaryColors } from 'src/types/globalTypes';
import { FaDownload } from 'react-icons/fa';
import SideList from 'src/components/layout/list/SideList';
import ToTop from 'src/components/ui-kit/ToTop';
import { useStore } from 'src/hooks/useStore';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 39px;
  height: max-content;
`;
const ImgDiv = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  @media (max-width: ${mobilePoint}) {
    display: none;
  }
`;
const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  width: 80%;
  gap: 3em;
  margin: 3em 0;

  @media (max-width: ${mobilePoint}) {
    grid-template-columns: 1fr;
    margin: 0;
    width: 100%;
    gap: 0;
  }
`;

// 輸出內容頁樣式
export const ContentWrapper = styled.div`
  display: grid;
  gap: 1.5em;
`;
export const MainContent = styled.div`
  background-color: ${colors.white};
  box-shadow: 0 0 5px rgba(67, 67, 67, 0.08);
  width: 100%;
  border-radius: 4px;
`;
export const SubContent = styled.div<{ color?: string }>`
  display: grid;
  gap: 2em;
  border-bottom: 1px solid ${(prop) => prop.color};
  padding: 2em 2em;
`;
export const Item = styled.div`
  display: grid;
  grid-template-columns: 1fr 3fr 1fr;

  @media (max-width: ${mobilePoint}) {
    grid-template-columns: 1fr;
    gap: 1em;
  }
`;
export const ItemTitle = styled.div<{ required?: boolean }>`
  position: relative;
  text-align: left;
  ${(props) =>
    props.required &&
    css`
      padding-left: 8px;
      :before {
        content: '•';
        color: ${colors.notice_red};
        position: absolute;
        font-size: 20px;
        top: -12px;
        left: -6px;
      }
    `}

  @media (max-width: ${mobilePoint}) {
    font-family: NotoSansTC-Bold;
  }
`;
export const ItemContent = styled.div`
  display: grid;
  gap: 1em;
`;
export const CaptchaDiv = styled.div`
  display: flex;
  gap: 1em;
`;
export const ButtonDiv = styled.div`
  display: flex;
  width: fit-content;
  color: ${colors.white};
  padding: 1em 2em;

  @media (max-width: ${mobilePoint}) {
    width: 100%;
  }
`;
export const Button = styled.div<{ disable?: boolean }>`
  background-color: ${(props) => (props.disable ? colors.BlueGray_200 : colors.primaryGreen_500)};
  font-size: 18px;
  padding: 0.5em 1em;
  border-radius: 4px;
  cursor: ${(props) => (props.disable ? 'default' : 'pointer')};

  @media (max-width: ${mobilePoint}) {
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 1em 0;
  }
  
  &:focus {
    outline: 2px solid #000000;
    outline-offset: -2px;
  }
`;
export const Annotation = styled.div`
  color: ${colors.BlueGray_500};
  margin-bottom: 1.5em;

  @media (max-width: ${mobilePoint}) {
    margin: 0 1.5em 1.5em 1.5em;
  }
`;
export const ErrorMsg = styled.div`
  color: ${colors.notice_error};
`;

interface Iprops {
  title?: string;
  subtitle?: string;
  children: React.ReactNode;
  bannerBgImg: string;
  image: string;
  imgDot: string;
  bgColor: PrimaryColors;
}

/**
 * 電子證書功能頁
 */
const CertificatePage: React.FC<Iprops> = ({
  title,
  subtitle,
  children,
  bannerBgImg,
  bgColor,
  image,
  imgDot,
}) => {
  const isMobile = useStore((state) => state.isMobile);
  const mainTitle = title ? title : '電子證書';
  const sideList = [
    { title: '電子證書驗證', href: process.env.PUBLIC_URL + '/certificate/verify', icon: <BsFillPatchCheckFill /> },
    { title: '下載證書', href: process.env.PUBLIC_URL + '/certificate/download', icon: <FaDownload /> },
  ];
  const component = globalComponents.C;
  const colorType = component.color;

  return (
    <>
      {isMobile && <ToTop />}
      <ImgDiv>
        <ImgDiv>
          <PlaceImg image={imgDot} placeProps={{ height: '80px', top: '20%', right: '0%' }} />
          <PlaceImg image={imgDot} placeProps={{ height: '80px', top: '40%', left: '0%' }} />
        </ImgDiv>
      </ImgDiv>
      <Wrapper>
        <DetailBanner
          title={mainTitle}
          subtitle={subtitle}
          bgImg={bannerBgImg}
          image={image}
          bgColor={bgColor.sixth}
        />
        <Content>
          <SideList components={sideList} color={colorType.fifth} />
          {children}
        </Content>
      </Wrapper>
    </>
  );
};

export default CertificatePage;
